module.exports = require("./src/responsive-child/responsive-child.js");